import { connect, Field as FormikField } from 'formik'
import { SwitchBox } from '@/ui/atoms/switchBox'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getCurrentLanguage } from '@/i18next'
import { Button, Field } from '@/ui'
import { SelectPerson } from '@/components/SelectPerson/SelectPerson'
import styles from '@features/accidents/steps/accidentReport/Form.module.scss'
import { LANGUAGE_ENUM, useDebounce } from '@/shared'
import cl from 'classnames'
import { accidentThunks } from '@/entity'

let FORM_NAME = {
	injureds: 'injureds',
	isResident: 'isResident',
	iin: 'iin',
	fio: 'fio',
	surname: 'surname',
	firstname: 'firstname',
	secondname: 'secondname',
	birthDate: 'birthDate',
	gender: 'gender',
	passportNumber: 'passportNumber',
	issuredBy: 'issuredBy',
	issuredWhen: 'issuredWhen',
	establishedPost: 'establishedPost',
	positionCode: 'positionCode',
	diagnosis: 'diagnosis',
	code: 'code',
	nameKz: 'nameKz',
	nameRu: 'nameRu',
	positionNameKz: 'positionNameKz',
	positionNameRu: 'positionNameRu',
	icd: 'icd',

	//локальный стест чтоб знать, есть ли контракт у персоны
	isContract: 'isContract',
	//локальный стест для уникальности
	key: 'key',
	isValid: 'isValid',
}

export const InjuredItem = connect(
	({ formik: { setFieldValue, values, resetForm, setValues }, item, index, remove }) => {
		const { t } = useTranslation()
		const lang = getCurrentLanguage()
		const dispatch = useDispatch()

		const { genders, positionsByKnz, positions, person, icd } = useSelector((state) => ({
			genders: state.handbook.genders,
			positionsByKnz: state.handbook.positionsByKnz,
			positions: state.handbook.positions,
			person: state.accidents.person,
			icd: state.handbook.icd,
		}))

		useEffect(() => {
			if (positions.length) setLocalPositions(positions.map((i) => ({ ...i, key: i.code })))
		}, [positions, item.isResident])

		useEffect(() => {
			if (positionsByKnz.length) setLocalPositionsNkz(positionsByKnz.map((i) => ({ ...i, key: i.code })))
		}, [positionsByKnz])

		const [localPositions, setLocalPositions] = useState(positions.map((i) => ({ ...i, key: i.code, nkz: null })))
		const [localPositionsNkz, setLocalPositionsNkz] = useState(positionsByKnz.map((i) => ({ ...i, key: i.code })))
		const [searchText, setSearchText] = useState('')
		const debouncedSearchText = useDebounce(searchText, 500)

		const filteredPositions = useMemo(() => {
			return localPositions?.filter((i) => {
				let label = {
					[LANGUAGE_ENUM.rus]: i.rus,
					[LANGUAGE_ENUM.kz]: i.kz,
				}

				return label[lang].toLowerCase().includes(debouncedSearchText.toLowerCase())
			})
		}, [localPositions, debouncedSearchText])

		let validateSurname = (obj) => {
			let error
			if (!(!!obj.surname || !!obj.secondname || !!obj.firstname)) {
				error = t('accidentsPage.fio_condition_error')
			}
			return error
		}

		useEffect(() => {
			if (!filteredPositions?.length) {
				let res = {
					...values,
					injureds: values.injureds?.map((injured, injuredIdx) => {
						if (injuredIdx === index) {
							return {
								...injured,
								[FORM_NAME.establishedPost]: {
									[FORM_NAME.nameKz]: debouncedSearchText,
									[FORM_NAME.nameRu]: debouncedSearchText,
									[FORM_NAME.code]: null,
								},
							}
						} else {
							return injured
						}
					}),
				}

				setValues(res)
			}
		}, [debouncedSearchText])

		const handleOnSelectedPerson = (res = null, onSuccess = (res, isContract) => {}) => {
			let byPersonPosition =
				res.contractDatas?.map((i) => ({
					...i.establishedPost,
					kz: i.establishedPost?.nameKz,
					rus: i.establishedPost?.nameRu,
					nkz: { code: i.positionCode, rus: i.positionNameRu, kz: i.positionNameKz },
				})) || []
			let totalPosition = positions.map((i) => ({ ...i, key: i.code, nkz: null })) || []
			let conditionPosition = res.contractDatas ? byPersonPosition : totalPosition

			let byPersonPositionNkz =
				res.contractDatas?.map((i) => ({
					key: i.positionCode,
					code: i.positionCode,
					rus: i.positionNameRu,
					kz: i.positionNameKz,
				})) || []
			let totalPositionNkz = positionsByKnz.map((i) => ({ ...i, key: i.code })) || []
			let conditionPositionNkz = res.contractDatas ? byPersonPositionNkz : totalPositionNkz

			setLocalPositions(conditionPosition)
			setLocalPositionsNkz(conditionPositionNkz)

			onSuccess(res, !!res?.contractDatas)
		}

		return (
			<Fragment>
				<section>
					<h5>{t('accidentsPage.register.victim') + ' ' + (values.injureds?.length > 1 ? index + 1 : '')} </h5>

					<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.isResident}`}>
						{({ field }) => (
							<SwitchBox
								{...field}
								disabled={false}
								label={t('accidentsPage.register.resident')}
								onChange={(value) => {
									field.onChange(value)
									setLocalPositions(null)

									let res = {
										...values,
										injureds: values.injureds?.map((injured, injuredIdx) => {
											if (injuredIdx === index) {
												return {
													[FORM_NAME.isResident]: value,
												}
											} else {
												return injured
											}
										}),
									}
									setValues(res)
								}}
							/>
						)}
					</FormikField>

					{values.injureds?.length > 1 && (
						<Button buttonClassName={'float-end'} type="bare" onClick={() => remove(index)}>
							{t('remove')}
						</Button>
					)}
				</section>

				{item.isResident ? (
					<section>
						<div className={cl(styles.victimSection)}>
							<SelectPerson
								iinLabel={t('accidentsPage.victimIin')}
								fullNameLabel={t('employee_initials')}
								iinFieldName={`${FORM_NAME.injureds}.${index}.${FORM_NAME.iin}`}
								fullNameFieldName={`${FORM_NAME.injureds}.${index}.${FORM_NAME.fio}`}
								onChange={() => {
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.isValid}`, false)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.fio}`, false)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.firstname}`, false)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.secondname}`, false)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.surname}`, false)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.gender}`, null)
									setFieldValue(`${FORM_NAME.injureds}.${index}.${FORM_NAME.birthDate}`, null)
								}}
								onSelected={(personValues) =>
									handleOnSelectedPerson(personValues, (personData, isContract) => {
										let res = {
											...values,
											injureds: values.injureds?.map((injured, injuredIdx) => {
												if (injuredIdx === index) {
													return {
														[FORM_NAME.isResident]: injured.isResident,
														[FORM_NAME.isContract]: !!personValues?.contractDatas,
														[FORM_NAME.iin]: personValues?.iin,
														[FORM_NAME.fio]: personValues?.fio,
														[FORM_NAME.firstname]: personValues?.firstname,
														[FORM_NAME.secondname]: personValues?.secondname,
														[FORM_NAME.surname]: personValues?.surname,
														[FORM_NAME.isValid]: true,
														[FORM_NAME.gender]: personValues?.sexCode,
														[FORM_NAME.birthDate]: personValues?.birthDate,
													}
												} else {
													return injured
												}
											}),
										}
										setValues(res)
									})
								}
								onSearch={(value) => {
									let body = {
										data: {
											iin: values[FORM_NAME.injureds][index][FORM_NAME.iin],
										},
										...value,
									}
									dispatch(accidentThunks.getPerson(body))
								}}
							/>
							<div className={styles.ml}>
								<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.gender}`}>
									{({ field, meta: { touched, error } }) => (
										<Field
											{...field}
											fieldType="select"
											options={genders || []}
											isRequired
											label={t('gender')}
											placeholder={t('gender')}
											error={touched && error}
											disabled
										/>
									)}
								</FormikField>
							</div>
						</div>
					</section>
				) : (
					<>
						<section className={styles.victimNonResidentDocuments}>
							<FormikField
								name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.surname}`}
								validate={() => validateSurname(item)}
							>
								{({ field, meta: { error } }) => (
									<Field
										{...field}
										type="text"
										fieldType="input"
										label={t('accidentsPage.victimSurname')}
										placeholder={t('accidentsPage.placeholderSurname')}
										error={error}
									/>
								)}
							</FormikField>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.firstname}`}>
								{({ field }) => (
									<Field
										{...field}
										type="text"
										fieldType="input"
										label={t('accidentsPage.victimFirstname')}
										placeholder={t('accidentsPage.placeholderFirstname')}
									/>
								)}
							</FormikField>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.secondname}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="text"
										fieldType="input"
										label={t('accidentsPage.victimSecondName')}
										placeholder={t('accidentsPage.placeholderSecondName')}
										error={touched && error}
									/>
								)}
							</FormikField>
						</section>
						<section className={styles.victimNonResidentDocuments}>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.birthDate}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										style={{ width: '100%' }}
										fieldType="datePicker"
										label={t('accidentsPage.register.birthday')}
										placeholder={t('default_date_value')}
										isRequired
										maxDate={new Date()}
										error={touched && error}
									/>
								)}
							</FormikField>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.gender}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										fieldType="select"
										options={genders || []}
										isRequired
										label={t('gender')}
										placeholder={t('gender')}
										error={touched && error}
									/>
								)}
							</FormikField>
						</section>
						<section className={styles.victimNonResidentDocuments}>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.passportNumber}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="text"
										fieldType="input"
										label={t('accidentsPage.register.passport')}
										isRequired
										placeholder={t('accidentsPage.register.number')}
										error={touched && error}
									/>
								)}
							</FormikField>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.issuredBy}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										type="text"
										fieldType="input"
										label={t('accidentsPage.register.issuer')}
										isRequired
										placeholder={t('accidentsPage.register.issuerName')}
										error={touched && error}
									/>
								)}
							</FormikField>
							<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.issuredWhen}`}>
								{({ field, meta: { touched, error } }) => (
									<Field
										{...field}
										style={{ width: '100%' }}
										fieldType="datePicker"
										label={t('accidentsPage.register.takenDate')}
										placeholder={t('default_date_value')}
										isRequired
										maxDate={new Date()}
										error={touched && error}
									/>
								)}
							</FormikField>
						</section>
					</>
				)}

				<section>
					<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.establishedPost}.${FORM_NAME.key}`}>
						{({ field, meta: { touched, error } }) => {
							let value = {
								[LANGUAGE_ENUM.kz]:
									values?.[FORM_NAME.injureds]?.[index]?.[FORM_NAME.establishedPost]?.[FORM_NAME.nameKz],
								[LANGUAGE_ENUM.rus]:
									values?.[FORM_NAME.injureds]?.[index]?.[FORM_NAME.establishedPost]?.[FORM_NAME.nameRu],
							}
							return (
								<Field
									{...field}
									fieldType="selectSearch"
									isRequired
									label={t('contract.info.position')}
									placeholder={t('position_placeholder')}
									error={touched && error}
									optionObjectKey={FORM_NAME.key}
									filteredOption={filteredPositions}
									value={value?.[lang]}
									onSelect={(e) => {
										setSearchText(e.target.value)
									}}
									onChange={(value) => {
										let findEstablishedPost = localPositions?.find((i) => i.key === value)

										let res = {
											...values,
											injureds: values.injureds?.map((injured, injuredIdx) => {
												if (injuredIdx === index) {
													return {
														...injured,
														[FORM_NAME.establishedPost]: {
															[FORM_NAME.nameKz]: findEstablishedPost?.kz || value,
															[FORM_NAME.nameRu]: findEstablishedPost?.rus || value,
															[FORM_NAME.code]: findEstablishedPost?.code || null,
														},
														[FORM_NAME.positionCode]: findEstablishedPost?.nkz?.code || null,
														[FORM_NAME.positionNameKz]: findEstablishedPost?.nkz?.kz || null,
														[FORM_NAME.positionNameRu]: findEstablishedPost?.nkz?.rus || null,
													}
												} else {
													return injured
												}
											}),
										}

										setValues(res)
									}}
									disabled={person.loading}
								/>
							)
						}}
					</FormikField>
				</section>
				<section>
					<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.positionCode}`}>
						{({ field, meta: { touched, error } }) => (
							<Field
								{...field}
								options={localPositionsNkz}
								type="text"
								fieldType="selectSearch"
								isRequired
								label={t('contract.info.nkz_position')}
								placeholder={t('accidentsPage.register.positionNkz')}
								error={touched && error}
								disabled={person.loading || item?.isContract}
								onChange={(value) => {
									field.onChange(value)
									let findPositionsByNkz = localPositionsNkz?.find((i) => i.code === value)

									let res = {
										...values,
										injureds: values.injureds?.map((injured, injuredIdx) => {
											if (injuredIdx === index) {
												return {
													...injured,
													[FORM_NAME.positionCode]: findPositionsByNkz?.code,
													[FORM_NAME.positionNameKz]: findPositionsByNkz?.kz,
													[FORM_NAME.positionNameRu]: findPositionsByNkz?.rus,
												}
											} else {
												return injured
											}
										}),
									}

									setValues(res)
								}}
							/>
						)}
					</FormikField>
				</section>
				<section>
					<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.diagnosis}`}>
						{({ field, meta: { touched, error } }) => (
							<Field
								{...field}
								type="text"
								fieldType="input"
								isRequired
								label={t('accidentsPage.register.icd10NameProf')}
								placeholder={t('accidentsPage.register.selectIcd10')}
								disabled={false}
								error={touched && error}
								hint={t('accidentsPage.register.icd10NameProfHint')}
							/>
						)}
					</FormikField>
				</section>
				<section>
					<FormikField name={`${FORM_NAME.injureds}.${index}.${FORM_NAME.icd}`}>
						{({ field, meta: { touched, error } }) => (
							<Field
								{...field}
								options={icd}
								type="text"
								fieldType="selectSearch"
								label={t('accidentsPage.icd')}
								placeholder={t('choose_from_directory')}
								error={touched && error}
							/>
						)}
					</FormikField>
				</section>
			</Fragment>
		)
	}
)
